import { render, staticRenderFns } from "./newsSidebar.vue?vue&type=template&id=3401182b&scoped=true"
import script from "./newsSidebar.vue?vue&type=script&lang=js"
export * from "./newsSidebar.vue?vue&type=script&lang=js"
import style0 from "./newsSidebar.vue?vue&type=style&index=0&id=3401182b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401182b",
  null
  
)

export default component.exports